import { connect } from 'react-redux'
import Pagination from './Pagination'
import { selectionPaginationPrevious, selectionPaginationNext } from '../../actionCreators'
import { currentPage, maxPage } from '../../selectors/selectionPagination'

const mapStateToProps = (state, ownProps) => ({
   page: currentPage(state),
   maxPage: maxPage(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  onPrevious: () => dispatch(selectionPaginationPrevious()),
  onNext: () => dispatch(selectionPaginationNext())
})

export default connect(mapStateToProps, mapDispatchToProps)(Pagination)



// WEBPACK FOOTER //
// ./src/components/Selection/PaginationContainer.js